export const ERROR_MESSAGES= {
    USER_NAME: "User Name Required",
    SHORT_NAME: "Short Name Required",
    KEY_NAME: "Key Name Required",
    IP_ADDRESSES: "IPAddresses Required",
}
